import { useEffect, useRef, useState } from 'react';
import {  useFrame } from "@react-three/fiber"
import * as THREE from 'three';
import audioUrl from '../../../assets/audio/revo.mp3'

const ARR = [30,28,26,24,22,20,18,16,14,12,10,8,6,3,0,1,4,5,7,9,11,13,15,17,19,21,23,25,27,29,31];

function AudioVisualizer() {
  const [analyser, setAnalyser] = useState(null);
  const [dataArray, setDataArray] = useState(null);
  const barsRef = useRef([]);
  const barsRef2 = useRef([]);
  const barsRef3 = useRef([]);
  const [audio2] = useState(new Audio(audioUrl))

  useEffect(() => {
    audio2.crossOrigin = "anonymous";
    audio2.volume = 0.15
    audio2.loop = true
    audio2.play();
  }, [])


  useEffect(() => {
    if (analyser) return
    const initAudio = async () => {
      const audio = new Audio(audioUrl);
      audio.crossOrigin = "anonymous";
      audio.volume = 0.5
      audio.loop = true
      audio.play();

      audio.addEventListener('ended', () => {
        audio.currentTime = 0;  // Скидаємо час до початку
        audio.play();  // Починаємо відтворення знову
      });

      const context = new (window.AudioContext || window.webkitAudioContext)();
      const analyserNode = context.createAnalyser();
      analyserNode.fftSize = 256; // Розмір Fast Fourier Transform

      const source = context.createMediaElementSource(audio);
      source.connect(analyserNode);
      //analyserNode.connect(context.destination);

      const bufferLength = analyserNode.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      setAnalyser(analyserNode);
      setDataArray(dataArray);
    };

    initAudio();
  }, []);

  useFrame(() => {


    if (analyser && dataArray) {
      analyser.getByteFrequencyData(dataArray);
      // Оновлюємо висоту смуг відповідно до частотних даних
      barsRef.current.forEach((bar, index) => {
        const scale = dataArray[ARR[index]] / 256; // Нормалізуємо значення
        bar.scale.y = Math.max(0.1, scale) ; // Мінімальна висота
        bar.material.color = new THREE.Color(`hsl(${(scale * 120 + 10)}, 100%, 50%)`); // Динамічна зміна кольору
      });

      barsRef2.current.forEach((bar, index) => {
        const scale = dataArray[ARR[index]] / 256; // Нормалізуємо значення
        bar.scale.y = Math.max(0.1, scale) ; // Мінімальна висота
        bar.material.color = new THREE.Color(`hsl(${(scale * 120 + 120)}, 100%, 50%)`); // Динамічна зміна кольору
      });

      barsRef3.current.forEach((bar, index) => {
        const scale = dataArray[ARR[index]] / 256; // Нормалізуємо значення
        bar.scale.y = Math.max(0.1, scale) ; // Мінімальна висота
        bar.material.color = new THREE.Color(`hsl(${(scale * 120 + 240)}, 100%, 50%)`); // Динамічна зміна кольору
      });
    }
  });

  return (
    <>
      <group position={[-14.6, 2, -6.9]} rotation={[0, Math.PI / 2, 0]}>
        {[...Array(32)].map((_, index) => (
          <mesh
            key={index}
            position={[index * 0.075 - 8, 0, 0]}
            ref={(el) => (barsRef.current[index] = el)}
          >
            <boxGeometry args={[0.03, 1, 0.01]} />
            <meshBasicMaterial color="white" />
          </mesh>
        ))}
      </group>
      <group position={[-14.6, 2, -10.15]} rotation={[0, Math.PI / 2, 0]}>
        {[...Array(32)].map((_, index) => (
          <mesh
            key={index}
            position={[index * 0.075 - 8, 0, 0]}
            ref={(el) => (barsRef2.current[index] = el)}
          >
            <boxGeometry args={[0.03, 1, 0.01]} />
            <meshBasicMaterial color="white" />
          </mesh>
        ))}
      </group>

      <group position={[-14.6, 2, -13.3]} rotation={[0, Math.PI / 2, 0]}>
        {[...Array(32)].map((_, index) => (
          <mesh
            key={index}
            position={[index * 0.075 - 8, 0, 0]}
            ref={(el) => (barsRef3.current[index] = el)}
          >
            <boxGeometry args={[0.03, 1, 0.01]} />
            <meshBasicMaterial color="white" />
          </mesh>
        ))}
      </group>
    </>
  );
}

export {
  AudioVisualizer
}